import React from "react";
import { useContext } from "react";
import { VideosPopupContext } from "./VideosPopupContext";
import "./VideosPopup.css";

function VideosPopup() {
    const { popupState, closePopup } = useContext(VideosPopupContext)
    

    return(
        <React.Fragment>
        <div className="popupContainer" style={{ display: popupState.isPopupShown ? 'block' : 'none' }}>
                <button className="closeBtn" type="button" id="close" onClick={ closePopup }><img style={{ padding: '1px', background: '#fff' }} src="../../../ReactComponents/BecomePartner/close.svg" /></button>
                <div className="popupVideo">
                    <iframe src={`https://www.youtube.com/embed/${popupState.popupProps.VideoId}`}></iframe>
                </div>
                {/* <h3>{popupState.popupProps.VideoDescription}</h3> */}
            </div>
        </React.Fragment>
    )
}

export {VideosPopup}